import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import {
  getFakeClientUser,
  getUserRole,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { Route, Redirect } from 'react-router-dom';
import { setLoggedInUserThunk } from '../../common/redux/security/loggedInUser/setLoggedInUserThunk';
import authorizationService from '../../common/services/security/authorizationService';

import { PendoStarter } from '../userAnalytics/PendoStarter';

const PrivateRoute = ({
  component: Component,
  tAndCHasAccepted,
  requireTAndCAcceptance = true,
  ...rest
}) => {
  const dispatch = useDispatch();
  const hasValidToken = authorizationService.hasValidToken();
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const isFakeClientUser = useSelector(getFakeClientUser);

  useEffect(() => {
    if (hasValidToken) {
      dispatch(setLoggedInUserThunk(rest.path));
    }
  }, [hasValidToken, dispatch, rest.path]);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (hasValidToken) {
          if (
            requireTAndCAcceptance &&
            !isPwcUser &&
            !tAndCHasAccepted &&
            !isFakeClientUser
          ) {
            return (
              <Redirect to={{ pathname: '/', state: { from: location } }} />
            );
          }
          return (
            <PendoStarter>
              <Component />
            </PendoStarter>
          );
        }
        return (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
